export default __webpack_public_path__ + "static/Terrell_Davis_headshot-2a55b8f727534b1bb64dad952bb192fe.jpeg";